module.exports = __webpack_public_path__ + "static/media/soft.58ded75c.webp";